





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IPropertyInfoInput } from '@/modules/Property/interfaces/property-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    AppTextField,
    AppSelector
  }
})
export default class PropertyFormInfo extends Vue {
  @Prop({ type: Object as () => IPropertyInfoInput }) value!: IPropertyInfoInput

  states = states

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
